import React from 'react';
import { theme } from '../../theme';
import type { Achievement } from '../../types/achievement';

interface CatalogEntry {
  key: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

const CLIENT_CATALOG: CatalogEntry[] = [
  { key: 'first_match', name: 'Debut',            description: 'Jugaste tu primer partido',      icon: '⚽', color: '#888888' },
  { key: 'first_goal',  name: 'Primera Sangre',   description: 'Marcaste tu primer gol',         icon: '🥇', color: '#CD7F32' },
  { key: 'goals_10',    name: 'Goleador Novato',  description: '10+ goles marcados',             icon: '⚽', color: '#CD7F32' },
  { key: 'goals_20',    name: 'Goleador',         description: '20+ goles marcados',             icon: '⚽', color: '#C0C0C0' },
  { key: 'goals_50',    name: 'Goleador Experto', description: '50+ goles marcados',             icon: '⚽', color: '#FFD700' },
  { key: 'hat_trick',   name: 'Hat-Trick',        description: 'Marcaste 3 goles en un partido', icon: '🎩', color: '#FFD700' },
  { key: 'matches_10',  name: 'Fichado',          description: '10 partidos jugados',            icon: '📅', color: '#888888' },
  { key: 'mvp_first',   name: 'MVP',              description: 'Fuiste MVP por primera vez',     icon: '🌟', color: '#FFD700' },
];

interface Props {
  unlocked: Achievement[];
}

export const AchievementGrid: React.FC<Props> = ({ unlocked }) => {
  const ownedByKey = new Map(unlocked.map(a => [a.key, a]));

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
        gap: theme.spacing.sm,
        padding: theme.spacing.sm,
      }}
    >
      {CLIENT_CATALOG.map(def => {
        const owned = ownedByKey.get(def.key);
        return (
          <div
            key={def.key}
            data-testid={`achievement-grid-cell-${def.key}`}
            data-owned={owned ? 'true' : 'false'}
            title={owned ? def.description : 'Logro bloqueado'}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: theme.spacing.sm,
              backgroundColor: theme.colors.surface,
              borderRadius: theme.borderRadius.input,
              border: `1px solid ${owned ? def.color : theme.colors.border}`,
              opacity: owned ? 1 : 0.35,
              textAlign: 'center',
            }}
          >
            <span style={{ fontSize: '36px', marginBottom: 4 }} aria-hidden>
              {owned ? def.icon : '?'}
            </span>
            <span
              style={{
                color: owned ? theme.colors.text : theme.colors.textSecondary,
                fontSize: theme.fonts.sizeSmall,
                fontFamily: theme.fonts.body,
              }}
            >
              {owned ? def.name : 'Logro bloqueado'}
            </span>
          </div>
        );
      })}
    </div>
  );
};
